import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {ItemsService} from '../commons/items.service';

@Injectable({
    providedIn: 'root'
})
export class PartnerGroupsService extends ItemsService{


    constructor(public http2: HttpClient) {
        super(http2);
    }
    
    getServiceName(){
        return 'partnerGroup';
    }
    

}
